import HeatmapActionTypes from "../../constants/Applications/heatMap-actionTypes";

export const getHeatmapTableData = (data) => ({
  type: HeatmapActionTypes.GET_HEATMAP_TABLE_DATA,
  data: data,
});

export const getHeatmapDropdownData = (roleId) => ({
  type: HeatmapActionTypes.GET_HEATMAP_DROPDOWN_DATA,
  roleId: roleId,
});

export const updateHeatmapFormDataStart = (data, callback) => (
  {
    type: HeatmapActionTypes.UPDATE_HEATMAP_FORM_DATA_START,
    payload: data,
    callback
  }
)

export const updateHeatmapFormDataSuccess = () => (
  {
    type: HeatmapActionTypes.UPDATE_HEATMAP_FORM_DATA_SUCCESS,
  }
)

export const getHeatmapFormTableData = (customerId, toolId, servicedeskId) => ({
  type: HeatmapActionTypes.GET_HEATMAP_FORM_TABLE_DATA,
  customerId: customerId,
  toolId: toolId,
  servicedeskId: servicedeskId
});

export const getVishingDropdownData = (roleId) => ({
  type: HeatmapActionTypes.GET_VISHING_DROPDOWN_DATA,
  roleId: roleId,
});

export const updateVishingFormDataStart = (data, callback) => (
  {
    type: HeatmapActionTypes.UPDATE_VISHING_FORM_DATA_START,
    payload: data,
    callback
  }
)

export const updateVishingFormDataSuccess = () => (
  {
    type: HeatmapActionTypes.UPDATE_VISHING_FORM_DATA_SUCCESS,
  }
)

export const getVishingFormTableData = () => ({
  type: HeatmapActionTypes.GET_VISHING_FORM_TABLE_DATA,
});

export const getVishingValidateTicketNo = (ticketNo) => ({
  type: HeatmapActionTypes.GET_VISHING_VALIDATE_TICKET_NO,
  ticketNo: ticketNo
});
